// extracted by mini-css-extract-plugin
export var integrationButton = "_6f-0";